import { render, staticRenderFns } from "./TopicStories.vue?vue&type=template&id=fba76bee&scoped=true&"
import script from "./TopicStories.vue?vue&type=script&lang=js&"
export * from "./TopicStories.vue?vue&type=script&lang=js&"
import style0 from "./TopicStories.vue?vue&type=style&index=0&id=fba76bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba76bee",
  null
  
)

export default component.exports